var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18V18.5H18H19C19.1326 18.5 19.2598 18.5527 19.3536 18.6464C19.4473 18.7402 19.5 18.8674 19.5 19C19.5 19.1326 19.4473 19.2598 19.3536 19.3536C19.2598 19.4473 19.1326 19.5 19 19.5H1C0.867391 19.5 0.740214 19.4473 0.646446 19.3536C0.552679 19.2598 0.5 19.1326 0.5 19V1C0.5 0.867392 0.552678 0.740215 0.646447 0.646447C0.740215 0.552678 0.867392 0.5 1 0.5C1.13261 0.5 1.25979 0.552678 1.35355 0.646447C1.44732 0.740215 1.5 0.867392 1.5 1V18V18.5H2H4H4.5V18V15C4.5 14.8674 4.55268 14.7402 4.64645 14.6464C4.74021 14.5527 4.86739 14.5 5 14.5C5.13261 14.5 5.25979 14.5527 5.35355 14.6464C5.44732 14.7402 5.5 14.8674 5.5 15V18V18.5H6H8H8.5V18V11C8.5 10.8674 8.55268 10.7402 8.64645 10.6464C8.74022 10.5527 8.86739 10.5 9 10.5C9.13261 10.5 9.25978 10.5527 9.35355 10.6464C9.44732 10.7402 9.5 10.8674 9.5 11V18V18.5H10H12H12.5V18V7C12.5 6.86739 12.5527 6.74022 12.6464 6.64645C12.7402 6.55268 12.8674 6.5 13 6.5C13.1326 6.5 13.2598 6.55268 13.3536 6.64645C13.4473 6.74022 13.5 6.86739 13.5 7V18V18.5H14H16H16.5V18V3C16.5 2.86739 16.5527 2.74021 16.6464 2.64645C16.7402 2.55268 16.8674 2.5 17 2.5C17.1326 2.5 17.2598 2.55268 17.3536 2.64645C17.4473 2.74021 17.5 2.86739 17.5 3V18Z",
    fill: "#222327",
    stroke: "#FFB800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedDashboard);
export default __webpack_public_path__ + "static/media/selected-dashboard.36eb736e47f3a686c5b427e8a0a9daa8.svg";
export { ForwardRef as ReactComponent };